<form class="col-12" *ngIf="promoCodeFrom" [formGroup]="promoCodeFrom">
  <div class="bg-white mb-3 ">
  <div class="border-bottom row mx-0 p-3">
    <h3>
      <span *ngIf="editMode">{{ 'Sellers.Products.Edit' | translate }}</span>
      <span *ngIf="!editMode">{{ 'Sellers.Products.Create' | translate }}</span>
      {{ 'Sellers.Products.PromoCode' | translate }}
    </h3>
  </div>
</div>
  <div class="cardbg-white p-3">
    <div class="row justify-content-end mx-0">
      <div class="col-12 col-sm-4 mb-3" >
        <mat-form-field appearance="outline" class="w-100">

        <mat-label>{{ 'Sellers.Products.Name' | translate }} <span class="text-danger">*</span></mat-label>
        <input type="text" placeholder="{{ 'Sellers.Products.Name' | translate }}"
               class="form-control"
               matInput
               formControlName="codeName"
               [readonly]="editMode" />
        <mat-error class="text-danger"
               *ngIf="formValidator?.formErrors?.codeName">
          {{formValidator.formErrors.codeName}}
        </mat-error>
      </mat-form-field >

      </div>
      <div class="col-12 col-sm-4 mb-3">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>{{ 'Sellers.Products.Products' | translate }}  <span class='text-danger'>*</span></mat-label>
        <mat-select (selectionChange)="productChange($event)"
                     class=" product"
                    style="height: 46px;margin-top: -20px;" formControlName="NewProductId" multiple>
          <mat-option *ngFor="let option of products" [value]="option.id">{{ option.name }}</mat-option>
        </mat-select>
        <mat-error class="text-danger" *ngIf="formValidator?.formErrors?.NewProductId">
          {{ formValidator.formErrors.NewProductId }}
        </mat-error>
    </mat-form-field >
      </div>

      <div class="col-12 col-sm-4 mb-3">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>{{ 'Sellers.Products.Expiry' | translate }} <span class="text-danger">*</span></mat-label>
          <div class="input-group position-relative">
            <input id="inDate" type="datetime"
                  class="form-control"
                  matInput
                  formControlName="expiry"
                  [matDatepicker]="picker"
                  placeholder="DD/MM/YYYY"
                  (click)="picker.open()" />
            <mat-datepicker-toggle style="position: absolute; right: 0px; z-index:20"
                                  [for]="picker"></mat-datepicker-toggle>
          </div>
          <mat-datepicker #picker
                          startView="month"
                          [startAt]="Datenow"></mat-datepicker>
          <mat-error class="text-danger"
                *ngIf="formValidator?.formErrors?.expiry">
            {{formValidator.formErrors.expiry}}
          </mat-error>
        </mat-form-field>
      </div>
      <div class="col-12 col-sm-4 mb-3" *ngIf="showAvailableQuantity">
        <mat-form-field appearance="outline" class="w-100">

        <mat-label >{{ 'Sellers.Products.Quantity' | translate }} <ng-container *ngIf="showTicketInput">{{ 'Sellers.Products.NotIncludeEvents' | translate }}</ng-container><span class="text-danger">*</span></mat-label>
        <input type="number"
               min="0" placeholder="{{ 'Sellers.Products.Quantity' | translate }}"
               formControlName="availableQuantity" matInput />
        <mat-error class="text-danger"
               *ngIf="formValidator?.formErrors?.availableQuantity">
          {{formValidator.formErrors.availableQuantity}}
        </mat-error>
      </mat-form-field>
      </div>
      <div class="col-12 col-sm-4 mb-3" *ngIf="showTicketInput">
        <mat-form-field appearance="outline" class="w-100">
        <mat-label>{{ 'Sellers.Products.TicketQuantity' | translate }} ({{ 'Sellers.Products.OnlyEvents' | translate}})<span class="text-danger">*</span></mat-label>
        <input type="number"
               min="1" placeholder="{{ 'Sellers.Products.TicketQuantity' | translate }}"
               formControlName="ticketQuantity" matInput/>
        <mat-error class="text-danger"
               *ngIf="formValidator?.formErrors?.ticketQuantity">
          {{formValidator.formErrors.ticketQuantity}}
        </mat-error>
      </mat-form-field>
      </div>
      <div class="col-12 col-sm-4 mb-3">
        <mat-form-field appearance="outline" class="w-100">

        <mat-label>{{ 'Sellers.Products.Type' | translate }} <span class="text-danger">*</span></mat-label>
        <mat-select
                    placeholder="{{ 'Sellers.Products.Type' | translate }}" class=" product" [disabled]="editMode"
                    style="height: 46px;margin-top: -20px;" formControlName="type" (selectionChange)="handleTypeValidation($event)">
          <mat-option *ngFor="let option of typeOptions" [value]="option">{{ typeTranslation[option] | translate }}</mat-option>
        </mat-select>
        <mat-error class="text-danger" *ngIf="formValidator?.formErrors?.Type">
          {{ formValidator.formErrors.Type }}
        </mat-error>
      </mat-form-field>

      </div>
      <div class="col-12 col-sm-4 mb-3">
        <mat-form-field appearance="outline" class="w-100 pb-3">
        <mat-label>{{ 'Sellers.Products.value' | translate }} <span class="text-danger">*</span></mat-label>
        <input type="number" min="1"
              matInput
               class="form-control"
               formControlName="precentage"
               placeholder="{{ 'Sellers.Products.value' | translate }}"
               [attr.disabled]="editMode ? '': null" />
        <mat-error class="text-danger"
               *ngIf="formValidator?.formErrors?.precentage">
          {{formValidator.formErrors.precentage}}
        </mat-error>
      </mat-form-field>
      <span class="text-danger" id="flatOptionMsg"></span>
      </div>
      <div class="col mb-3">
        <mat-form-field appearance="outline" class="w-100">

        <mat-label>{{ 'Sellers.Products.Description' | translate }}</mat-label>
        <input class="form-control" type="text" formControlName="description" matInput
               placeholder="{{ 'Sellers.Products.Description' | translate }}" />
        <mat-error class="text-danger"
               *ngIf="formValidator?.formErrors?.description">
          {{ formValidator.formErrors.description }}
        </mat-error>
      </mat-form-field >

      </div>
      <div class="w-100 ">
        <button class="w-100 btn btn-primary" (click)="onSubmit(promoCodeFrom.value)" [disabled]="promoCodeFrom.invalid">
          <ng-container *ngIf="editMode;else addMode">
            {{ 'Sellers.Products.EditPromocode' | translate }}
          </ng-container>
          <ng-template #addMode>
            {{ 'Sellers.Products.AddPromocode' | translate }}
          </ng-template>
        </button>
      </div>
    </div>
  </div>
</form>
